import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEyedropper2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eyedropper-2, color-picker, pipette, suction-tube, labor"><path d="M17 3L3.75 16.25V20.25H7.75L21 7L17 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10 7L17 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEyedropper2;
